import { render } from "./PageOzellikTanimlari.vue?vue&type=template&id=36405b1a&scoped=true"
import script from "./PageOzellikTanimlari.vue?vue&type=script&lang=js"
export * from "./PageOzellikTanimlari.vue?vue&type=script&lang=js"

import "./PageOzellikTanimlari.vue?vue&type=style&index=0&id=36405b1a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36405b1a"

export default script